// extracted by mini-css-extract-plugin
export default {"avatar":"s0YNvqIidn7i2Pn6uMqS"};